import Vue from "vue";
import Router from "vue-router";
import jwtData from "jwt-decode";
import { get as getCookie } from "js-cookie";
import routes from "@/modules/routes.js";
import store from "@/store";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    ...routes,
    ...[
      {
        path: "*",
        component: () => import("@/views/NotFound")
      }
    ]
  ]
});

router.beforeEach((to, from, next) => {
  const isAuthorized = to.matched.some(({ meta }) => meta.isAuthorized);
  const isAdmin = to.matched.some(({ meta }) => meta.isAdmin);
  const isMaintainer = to.matched.some(({ meta }) => meta.isMaintainer);
  const isMember = to.matched.some(({ meta }) => meta.isMember);
  const userToken = getCookie("jwt");

  if (isAuthorized) {
    if (!userToken) {
      store.dispatch("AUTH_UNSET").then(() => {
        return next({
          name: "home",
          params: {
            errors: [{ message: "Session expired. Please sign in again." }],
            return: to.fullPath
          }
        });
      });
    }

    const { roles } = jwtData(userToken);

    if (isAdmin) {
      // Proceed to admin route.
      if (roles.some(role => role >= 8)) {
        return next();
      }
    }

    if (isMaintainer) {
      // Proceed to maintainer route.
      if (roles.some(role => role >= 2)) {
        return next();
      }
    }

    if (isMember) {
      // Proceed to maintainer route.
      if (roles.some(role => role >= 0)) {
        return next();
      }
    }

    return next({
      name: "home",
      params: {
        errors: [{ message: "Unauthorized access." }],
        return: to.fullPath
      }
    });
  }

  next();
});

export default router;
